import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "align-right-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M3.25 3.8313C3.25 3.37219 3.58579 3 4 3H20C20.4142 3 20.75 3.37219 20.75 3.8313C20.75 4.29042 20.4142 4.66261 20 4.66261H4C3.58579 4.66261 3.25 4.29042 3.25 3.8313Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.25 9.37332C7.25 8.9142 7.58579 8.54202 8 8.54202H20C20.4142 8.54202 20.75 8.9142 20.75 9.37332C20.75 9.83244 20.4142 10.2046 20 10.2046H8C7.58579 10.2046 7.25 9.83244 7.25 9.37332Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M3.25 14.9153C3.25 14.4562 3.58579 14.084 4 14.084H20C20.4142 14.084 20.75 14.4562 20.75 14.9153C20.75 15.3745 20.4142 15.7466 20 15.7466H4C3.58579 15.7466 3.25 15.3745 3.25 14.9153Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M11.25 20.4574C11.25 19.9982 11.5858 19.6261 12 19.6261H20C20.4142 19.6261 20.75 19.9982 20.75 20.4574C20.75 20.9165 20.4142 21.2887 20 21.2887H12C11.5858 21.2887 11.25 20.9165 11.25 20.4574Z"
    }, null, -1)
  ])))
}
export default { render: render }